
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.116 12a.668.668 0 01-.303-.072L6.5 10.242l-3.313 1.686a.668.668 0 01-.685-.048.632.632 0 01-.22-.272.61.61 0 01-.038-.344l.632-3.57-2.68-2.529a.61.61 0 01.035-.932.66.66 0 01.325-.141l3.705-.521L5.917.322a.667.667 0 01.247-.236.695.695 0 01.919.236l1.656 3.249 3.705.52a.66.66 0 01.325.142.61.61 0 01.035.932l-2.68 2.529.632 3.57a.61.61 0 01-.143.512.648.648 0 01-.497.224z"}})])
          )
        }
      }
    